import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import useUpdateWatchedMovies from "./useUpdateWatchedMovies";
import CryptoJS from "crypto-js";
import { encryptId } from "../utils/encryption";

function usePlayVideo() {
  // const { addToWatchedMovies } = useUpdateWatchedMovies();
  const navigate = useNavigate();
  const location =useLocation();
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  
  // const encryptId = (id) => {
  //   try {
  //     const idString = String(id);
  //     const encryptedId = CryptoJS.AES.encrypt(idString, secretKey).toString();
      
  //     // Remove non-alphanumeric characters, keeping only A-Z, a-z, and 0-9
  //     return btoa(encryptedId)
  //   } catch (error) {
  //     console.error("Encryption error:", error);
  //     return null;
  //   }
  // };
  const playVideo = React.useCallback((videoId, type, catId, subCatId, season) => {
    const navigationFrom = location.pathname;
    const encryptedId = encryptId(videoId);
  
    console.log('Navigating from:', navigationFrom);
    console.log('Navigating to:', `/playVideo/${encryptedId}`);
  
    navigate(`/playVideo/${encryptedId}`, {
      state: {
        needsId: catId ? true : false,
        type: type,
        catId: catId,
        subCatId: subCatId,
        season: season,
        from: navigationFrom, // Consistent key with previous example
      },
      // Removed replace: true to preserve navigation history
    });
  }, [navigate, location.pathname, encryptId]);

  return { playVideo }; 
}

export default usePlayVideo;
